//微信浏览器
export default function () {
  const ua = window.navigator.userAgent.toLowerCase();
  return /micromessenger/.test(ua);
}